import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TABLES } from '../../../../../Apis/Tables';
import { MODELS } from '../../../../../Apis/Models';
import { useCallback, useEffect, useState } from 'react';
import { GetContractorEmployeeDetail } from '../../../../../reduxToolkit/Contractor/ContractorApi';
import {
    getColumnsEmployeeDetailsProvider,
    getSectionsEmployeeDetailsProvider
} from '../../../../Dashboard/Contractors/Model/Models';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import { errorMsg } from '../../../../../Apis/functions';
import { GetProviderEmployeeDetail } from '../../../../../reduxToolkit/Providers/providersApi';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const EmployeeDetailsDocumentationApp = (
    {
        userType
    }
) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const option = `${TABLES.USER_ACCESS_LOG}`;
    const moduleId = `${MODELS.UserAccessLog}`;
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [elementDetails, setElementDetails] = useState(null);

    useEffect(() => {
        getDetails();
    }, [id]);

    const getDetails = () => {
        if (!id) return;

        const actionByType = {
            [USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE]: GetContractorEmployeeDetail,
            [USER_TYPE_MODEL.SUPPLIER_IN_CHARGE]: GetProviderEmployeeDetail,
        };

        const action = actionByType[userType];
        if (!action) return;

        dispatch(action(id)).then(({ payload: { data: { data, success, code } } }) => {
            if (success === true) setElementDetails(data);
            else errorMsg(code);
        });
    }

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const columns = getColumnsEmployeeDetailsProvider(t, moduleId, option, id);
    const sections = getSectionsEmployeeDetailsProvider(
        {
            userTypeId: userType,
            userId: elementDetails?.user?.id,
            option
        });

    const renderExpandedRow = useCallback(({ row }) => row.content(), []);

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl?.pathname || state.backUrl, { state: { currentSubView: state?.currentSubView || undefined}});
        }
    };

    return {
        id,
        t,
        option,
        moduleId,
        expandedRowId, setExpandedRowId,
        handleRowExpand,
        columns,
        sections,
        renderExpandedRow,
        goBack,
        elementDetails,
        setElementDetails
    }

}

export default EmployeeDetailsDocumentationApp
